var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 4.81667C1.33333 5.60556 1.59722 6.28333 2.125 6.85C2.65278 7.41667 3.31111 7.73333 4.1 7.8L3.06667 6.76667L4 5.83333L6.66667 8.5L4 11.1667L3.06667 10.2333L4.13333 9.16667C2.96667 9.1 1.98611 8.65 1.19167 7.81667C0.397222 6.98333 0 5.98889 0 4.83333C0 3.62222 0.419444 2.59722 1.25833 1.75833C2.09722 0.919445 3.12222 0.5 4.33333 0.5H6.66667V1.83333H4.33333C3.5 1.83333 2.79167 2.12222 2.20833 2.7C1.625 3.27778 1.33333 3.98333 1.33333 4.81667ZM8 9.16667V7.83333H13.3333V9.16667H8ZM8 5.5V4.16667H13.3333V5.5H8ZM8 1.83333V0.5H13.3333V1.83333H8Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropMenu);
export default __webpack_public_path__ + "static/media/dropMenu.e22686a80c2bf660c18dc07675d9f7b8.svg";
export { ForwardRef as ReactComponent };